import { getItem } from '@sketch/utils'

/*
  This util provides the URL Scheme that Sketch app understands,
  allowing us to interact with the Mac app
  
  It replaces the URL's `http` or `https` scheme with `sketch`, or 
  a equivalent debug variant. Opening the resulting URL in the 
  browser will redirect the user to the Mac app, and perform the 
  appropriate action, like opening a share, adding a library, etc.

  These are the possibilities for the different environments:
  production -> sketch://sketch.com/s/…
  test -> sketch://test.sketch.com/s/...
  staging -> sketch://staging.sketch.com/s/...
  dev -> sketch://dev.sketch.com/s/...
  private -> sketch://acme.privatecloud.sketch.com/s/…
*/
export const setSketchUrlScheme = (url: string) => {
  url = url.replace(/(^https?:|^)\/\//, '')

  // Mac app versions before 2025.1 do not support the `www` subdomain
  url = url.replace(/(^www\.|^)/, '')

  const sketchAppVariant = getItem('debug.sketchAppVariant')

  return `${getVariantProtocol(sketchAppVariant)}://${url}`
}

const acceptedSketchVariants = [
  'appstore',
  'appstore-xcode',
  'beta',
  'experimental',
  'xcode',
]

export const getVariantProtocol = (sketchVariant: string = '') =>
  acceptedSketchVariants.includes(sketchVariant)
    ? `sketch-${sketchVariant}`
    : 'sketch'
